import React from 'react';

import Layout from './index';

function Full(props) {
  return (
    <Layout
      variant="full"
      {...props}
    />
  );
}

export default Full;
